import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import { FORM_TEMPLATE_TYPES } from "constants/form-templates";
import { FormTemplate } from "services/types/form-templates.type";

type FormTemplateListItemProps = {
  props: React.ComponentProps<typeof ListItem>;
  option: FormTemplate;
};

export default function FormTemplateListItem({
  props,
  option
}: FormTemplateListItemProps) {
  return (
    <ListItem
      {...props}
      key={option.id}
      sx={{
        ...props?.sx,
        mt: -0.5
      }}
      data-testid="form-template-item"
    >
      <ListItemText
        secondary={FORM_TEMPLATE_TYPES.getFromCode(option.type as number)}
      >
        {option.title}
      </ListItemText>
    </ListItem>
  );
}
